import { CheckCircle2, MapPin } from "lucide-react";

const ARTIST_IMG = "/studio3.png";

const traits = [
    "Custom-only — no flash, no copies",
    "Single-needle precision & bold blackwork",
    "Coverups that actually disappear",
    "Comfortable studio. No rushed sessions.",
];

export const About = () => {
    return (
        <section
            id="about"
            data-testid="about-section"
            className="relative py-24 md:py-32 bg-[#0a0a0a] overflow-hidden"
        >
            <div className="absolute -left-20 top-1/2 -translate-y-1/2 hidden lg:block opacity-[0.06] pointer-events-none">
                <div className="font-display text-[16rem] leading-none stencil-stroke">SHAWN</div>
            </div>

            <div className="relative max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
                <div className="lg:col-span-5 order-2 lg:order-1">
                    <div className="relative">
                        <div className="absolute -top-4 -left-4 w-24 h-24 border-2 border-[#7CFC00] z-0 pulse-glow" />
                        <div className="relative z-10 overflow-hidden border border-white/10">
                            <img
                                src={ARTIST_IMG}
                                alt="Shawn — TATZBYB4NK"
                                className="w-full h-[480px] md:h-[560px] object-cover grayscale contrast-110"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
                            <div className="absolute bottom-4 left-4 right-4">
                                <div className="font-script text-[#7CFC00] text-3xl">— Shawn</div>
                                <div className="text-zinc-300 text-sm uppercase tracking-widest mt-1">
                                    Owner / Artist
                                </div>
                            </div>
                        </div>
                        <div className="absolute -bottom-4 -right-4 w-24 h-24 border-2 border-white/20 z-0" />
                    </div>
                </div>

                <div className="lg:col-span-7 order-1 lg:order-2">
                    <div className="flex items-center gap-3 mb-4">
                        <div className="h-px w-10 bg-[#7CFC00]" />
                        <span className="text-[#7CFC00] uppercase tracking-[0.3em] text-xs font-semibold">
                            The Artist
                        </span>
                    </div>

                    <h2
                        data-testid="about-title"
                        className="font-display text-5xl md:text-7xl text-white uppercase tracking-tight leading-[0.95]"
                    >
                        Meet <span className="text-[#7CFC00] text-glow">B4NK</span>.
                        <br />
                        Built In Dallas.
                    </h2>

                    <p className="mt-6 text-zinc-300 text-lg leading-relaxed">
                        I'm Shawn — the hand behind every line at TATZBYB4NK. Started inking out of a homie's
                        garage, leveled up through long nights and louder critiques, and now I run my own room
                        between Dallas and Plano.
                    </p>
                    <p className="mt-4 text-zinc-400 text-base leading-relaxed">
                        I don't do flash sheets or recycled designs. Every piece is drawn for the person wearing
                        it. Your story, your style, my needle. The work speaks louder than I ever could.
                    </p>

                    <ul className="mt-8 space-y-3" data-testid="about-traits">
                        {traits.map((t, i) => (
                            <li key={i} className="flex items-start gap-3 text-zinc-200">
                                <CheckCircle2
                                    size={20}
                                    className="text-[#7CFC00] mt-0.5 flex-shrink-0"
                                />
                                <span>{t}</span>
                            </li>
                        ))}
                    </ul>

                    <div className="mt-10 flex flex-wrap items-center gap-6 border-t border-white/10 pt-6">
                        <div className="flex items-center gap-2 text-zinc-300">
                            <MapPin size={18} className="text-[#7CFC00]" />
                            <span className="text-sm uppercase tracking-widest">Dallas / Plano, TX</span>
                        </div>
                        <a
                            data-testid="about-ig-link"
                            href="https://instagram.com/tatzbyb4nk"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-sm uppercase tracking-widest text-zinc-300 hover:text-[#7CFC00] transition-colors border-b border-transparent hover:border-[#7CFC00] pb-0.5"
                        >
                            @tatzbyb4nk →
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};
